import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Select2Component } from './select2.component';
import {FormsModule} from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
      FormsModule
  ],
  declarations: [Select2Component],
    exports:[
      Select2Component
    ]
})
export class Select2Module { }




// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/select2/select2.module.ts